import { CcfBox, CcfTextField, CcfTypography } from '@nice-ccf/ui-controls';
import styles from './partner-access-control-new-user.module.scss';
import { CardContent, Paper } from '@mui/material';

/* eslint-disable-next-line */
export interface PartnerAccessControlNewUserProps {
  isTableOpen: any;
  setIsTableOpen: any;
  newUserDetails: any;
  setNewUserDetails: any;
  errors: any;
  setErrors: any;
}

/**
 * Component displays PartnerAccessControlNewUser
 * @param props -PartnerAccessControlNewUserProps
 * @returns app header component for landing screen
 * @example <PartnerAccessControlNewUser/>
 */
export function PartnerAccessControlNewUser(
  props: PartnerAccessControlNewUserProps
) {
  const { newUserDetails, setNewUserDetails, errors, setErrors } = props;

  /**
   * Used to validateEmail
   * @param email - input field values
   * @example
   */
  const validateEmail = (email: string) => {
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (reg.test(email) === false) {
      return false;
    }
    return true;
  };

  /**
   * Component displays PartnerAccessControlNewUser
   * @param props -PartnerAccessControlNewUserProps
   * @returns app header component for landing screen
   * @example <PartnerAccessControlNewUser/>
   */
  const handleInputChange = (key: any, e: any) => {
    setNewUserDetails({ ...newUserDetails, [key]: e });
    const newErrors = { ...errors };
    if (key === 'emailAddress') {
      const value = !validateEmail(e);
      if (value) {
        setErrors({
          ...errors,
          [key]: value,
        });
      } else {
        delete newErrors[key];
        setErrors(newErrors);
      }
    }

    if (key === 'userName' || key === 'password') {
      if (e.length < 6) {
        setErrors({
          ...errors,
          [key]: e.length < 6,
        });
      } else {
        delete newErrors[key];
        setErrors(newErrors);
      }
    }
  };

  return (
    <CcfBox
      className={styles.parentContainer}
      id="partnerAccessNewUserContainer"
    >
      <Paper elevation={3} className={styles.paperContainer}>
        <CardContent>
          <form
            // className={classes.root + ' ' + classes.simulatorForm}
            noValidate
            autoComplete="off"
            className={styles.feildBlockParent}
          >
            {Object.entries(newUserDetails).map(([key, value]) => (
              <CcfBox className={styles.feildBlock}>
                <CcfBox style={{ display: 'flex', gap: '2px' }}>
                  <CcfTypography className={styles.tableHeaderText}>
                    {key.replace(/([A-Z])/g, ' $1').trim()}
                  </CcfTypography>
                  {key !== 'middleName' && (
                    <span style={{ color: 'red' }}> *</span>
                  )}
                </CcfBox>
                <CcfTextField
                  id={key}
                  variant="outlined"
                  size="small"
                  value={value}
                  focused={false}
                  style={{ width: '80%' }}
                  InputProps={{
                    className: styles.inputTxt,
                  }}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleInputChange(key, event?.target.value)
                  }
                  error={errors[key]}
                  helperText={
                    (key === 'userName' || key === 'password') && errors[key]
                      ? 'Must be at least 6 characters'
                      : key === 'emailAddress' && errors[key]
                      ? 'Invalid Email'
                      : ''
                  }
                  FormHelperTextProps={{ style: { margin: '0' } }}
                />{' '}
              </CcfBox>
            ))}
          </form>
        </CardContent>
      </Paper>
    </CcfBox>
  );
}

export default PartnerAccessControlNewUser;
